/* eslint-disable multiline-ternary */
/* eslint-disable max-len */
/* eslint-disable no-console */
import React, { useContext, useMemo, useState } from 'react';
import { Box, Grid, Menu, MenuItem, Typography } from '@mui/material';
import { MdOutlineMoreHoriz } from 'react-icons/md';
import { GoThumbsup } from 'react-icons/go';
import { HiThumbUp } from 'react-icons/hi';
import { LanguageContext } from '../../../../../../../libs/Context';
import { catchErr, DateDiff, Formatter, userFullName } from '../../../../../../../libs/HelperContent';
import { deleteCommentApi, updateCmntAction, updateEventLikes } from '../../../../../../actions/feeds_actions_new';
import CommentReply from '../CommentReplies/CommentReply';
import NewDialogPopup from '../../../../../../../components/Common/NewDialogPopup/NewDialogPopup';
import { useSelector } from 'react-redux';
import { commentContext } from '../..';
import { deleteEventComment } from '../../../../../../actions/recognition_actions';
import AvatarListPopup from '../../../../../../../components/Common/AvatarListPopup';
import { feedActionContext } from '../../../../..';
import { feedActionContextFromExternal } from '../../../../ExternalRequest';
import ProfilePic from '../../../../../../../components/Common/ProfilePic';
import useFeedApproval from '../../../../LeftPart/FeedCreation/CustomHooks/useFeedApproval';

interface Props{
	cmntData:any;
	index:number;
	commntsData:any[];
	setCommntsData:(val)=>void;
	from:'feeds'|'events';
	selEvent:any;
	handleUpdate:(val)=>void;
}

const IndividualCmnt = (props:Props) =>
{
	const {
		cmntData, // mapped comment data
		index,
		commntsData, // original comments data
		setCommntsData,
		from,
		selEvent,
		handleUpdate } = props;

	const { language } = useContext(LanguageContext);
	const { handleFeedAction, feedAction } = useContext(window.location.pathname.includes('news') ? feedActionContext : feedActionContextFromExternal);
	const [ showMore, setShowMore ] = useState(false);
	const [ anchorEl, setAnchorEl ] = useState(null);
	const [ likePop, setLikePop ] = useState(false);
	const openMenu = Boolean(anchorEl);
	const [ openMoreReplies, setOpenMoreReplies ] = useState(false);
	const userData = useSelector((state:any) => state?.mysession?.session);
	const { action, setAction } = useContext(commentContext);
	const [ buttonDisable, setButtonDisable ] = useState(false);

	const shouldShowMore = cmntData?.comment?.length > 35;
	const displayedComment = showMore ? cmntData?.comment : `${cmntData?.comment?.substring(0, 35)}`;

	const actionKeys = Object?.keys(action)?.length > 0 && Object?.entries(action)[0];

	const { feedCardActn } = useContext(feedActionContext);

	const currentUser = useSelector((state:any) => state?.mysession?.userConfigs);
	const { isFeedsAdmin } = useFeedApproval();
	// Check if the comment can be hidden
	const canHide = useMemo(() =>
	{
		// Prevent runtime errors by adding checks to ensure that operations like Object.keys() and array indexing are only performed on valid values.
		if (currentUser?.companyId === feedCardActn?.[1]?.createdBy)
		{
			return isFeedsAdmin;
		}
		else if (feedCardActn?.[1]?.createdBy === currentUser?.userId)
		{
			return true;
		}

		return false;
	}, [
		currentUser?.companyId,
		currentUser?.feedManagement,
		currentUser?.userId,
		feedCardActn,
		isFeedsAdmin
	]);

	// Generate body for the API request
	const generateBody = (type, data) =>
	{
		let body;

		if (type === 'updateLike')
		{
			body = {
				like      : !data?.selfLike,
				commentId : cmntData?._id,
				...(from === 'events'
					? { eventId: selEvent?.eventId }
					: { userData: { userId: userData?.userId, firstName: userFullName(userData) } })
			};
		}
		else
		{
			body = {
				hide      : !data?.hideComment,
				commentId : cmntData?._id
			};
		}

		return body;
	};

	// Update comment
	const handleUpdateCmnt = async (type, data) =>
	{
		try
		{
			const body = generateBody(type, data);

			const res = from === 'events'
				? await updateEventLikes(body) // Update likes for events
				: await updateCmntAction(body); // Update likes for feeds

			if (res?.status)
			{
				if (type === 'updateLike')
				{
					const updteIndex = commntsData?.findIndex((itemD) => itemD._id === data?._id);

					if (updteIndex === -1) return; // Ensure valid index

					const updatedViewData = [ ...commntsData ];
					const likeCount = updatedViewData[updteIndex]?.[from === 'feeds' ? 'likesCount' : 'likeCount'] || 0;

					updatedViewData[updteIndex] = {
						...updatedViewData[updteIndex],
						likesCount : from === 'feeds'
							? body?.like ? likeCount + 1 : likeCount - 1
							: updatedViewData[updteIndex]?.likesCount,

						likeCount : from === 'events'
							? body?.like ? likeCount + 1 : likeCount - 1
							: updatedViewData[updteIndex]?.likeCount,

						selfLike : body?.like
					};

					setCommntsData(updatedViewData);
				}

				else if (type === 'updateHide')
				{
					setCommntsData((prevData) =>
						prevData.map((comment) =>
							(comment._id === data._id ? { ...comment, hideComment: !data?.hideComment } : comment)
						)
					);
				}

				else
				{
					const dataD = commntsData?.filter((itemD) => itemD?._id !== data?._id);

					setCommntsData(dataD);
					handleFeedAction('append', 'comments_add', feedAction.comments_add - 1);
				}
			}
			else
			{
				console.warn('Update failed, resetting state...');
				setCommntsData(commntsData); // Reset state in case of failure
			}
		}
		catch (err)
		{
			console.error('Error in handleUpdateCmnt:', err);
			catchErr?.(err); // Ensure catchErr is defined before calling
		}
	};

	// Delete comment
	const deleteComment = async () =>
	{
		if (buttonDisable)
		{
			return;
		}
		try
		{
			setButtonDisable(true);
			const query:any = {
				uid     : userData?.userId,
				comid   : userData?.companyId,
				empRole : userData?.empRole,
				role    : userData?.role

			};
			const path = from === 'events' ? actionKeys[1]?.commentId : actionKeys[1]?._id;
			const res = from === 'events' ? await deleteEventComment(path, query) : await deleteCommentApi(path, query);

			if (res?.status)
			{
				const updatedRepliesData = commntsData?.filter((item) => item?._id !== actionKeys[1]?._id);

				setCommntsData(updatedRepliesData);
				handleFeedAction('append', 'comments_add', updatedRepliesData.length);
				setButtonDisable(false);
			}
			else
			{
				setCommntsData(commntsData);
				setButtonDisable(false);
			}
		}
		catch (err)
		{
			console.log(err);
			setButtonDisable(false);
			catchErr(err);
		}
		finally
		{
			setAction({});
			setButtonDisable(false);
		}
	};

	// Handle click event for more options
	const handleClick = (event) =>
	{
		setAnchorEl(event.currentTarget);
	};

	// Check if the URL is a GIF
	const isGif = (url) =>
	{
		return /\.(gif)$/i.test(url);
	};

	// Open more replies
	const openReplies = () =>
	{
		setOpenMoreReplies(!openMoreReplies);
	};

	// Avatar URL
	const avatarUrl = useMemo(() =>
	{
		const userId = from === 'events' ? cmntData?.userId : cmntData?.userData?.userId;

		// Map the comment based user_id : cmntData > userData:{userId, firstName}
		return userId ? `${process.env.REACT_APP_S3_BASE_URL}/profile/${userId}_profile.jpeg` : '/images/icons/defaultUser.svg';
	}, [ cmntData ]);

	// Handle error
	const handleError = (event: any) =>
	{
		event.currentTarget.src = '/images/icons/defaultUser.svg';
	};

	// Check if the comment is from the user
	const checkFromEventsOrFeed = (from === 'events' ? cmntData?.userId : cmntData?.createdBy) === userData?.userId;

	// Check if the current user is the comment owner
	const isCurrentUser = from === 'events'
		? cmntData?.userId === userData?.userId
		: cmntData?.userData?.userId === userData?.userId;

	return (
		<>
			<Box p='var(--pixel8)'>
				<Grid
					container
					key={index}
					py='var(--pixel8)'
					borderBottom={index === commntsData?.length - 1 ? 'none' : '1px solid #E6E4EA'}
				>
					<Grid item xs={12} container >
						<Grid item >
							{/* <Box component='img' border='1px solid #E6E4EA' borderRadius='50%'
								width={32} height={32}
								src={avatarUrl}
								alt='comment_profile_pic'
								onError={handleError}
							/> */}
							<Box display='inline-flex'
								height={32}
								width={32}
								alignItems='center'
								justifyContent='center'
							>

								<ProfilePic
									imagePath={avatarUrl}
									defaultImg='/images/icons/defaultUser.svg'
									loadUrl='profile'
									alt='createdBy_img'
									className='brdrRadius50'
								/>
							</Box>

							{/* <Avatar sx={{ width: 32, height: 32, border: '1px solid #E6E4EA' }}
								 	onError={handleError}
								 	alt='comment_profile_pic'
								 	src={avatarUrl}
								 /> */}

						</Grid>
						<Grid item xs sx={{ minWidth: 0, overflow: 'hidden' }} spacing={0.5} px='var(--pixel8)'>
							<Box sx={{ minWidth: 0, overflow: 'hidden' }}>
								<Box sx={{ minWidth: 0, overflow: 'hidden', display: 'flex' }} alignItems='center'>
									<Typography variant='inherit' component='span' fontWeight='var(--font500)'
										sx={{
											whiteSpace   : 'nowrap',
											overflow     : 'hidden',
											textOverflow : 'ellipsis'
										}}
									>
										{isCurrentUser ? 'You' : cmntData?.userData?.firstName}
										{/* <Typography component='span' color='#536471' variant='caption'
											ml={0.5}
											sx={{
												position    : 'relative',
												'&::before' : {
													content         : '""',
													position        : 'absolute',
													left            : 0,
													top             : '4px',
													height          : '64%',
													width           : '1px',
													backgroundColor : '#536471'
												}
											}}
										>
											{nameStatus}
										</Typography>  */}
									</Typography>
									<Typography variant='caption' component='span' pl={0.9} color='#536471' sx={{ display: 'flex', flex: 'none' }}>
										{DateDiff(cmntData?.updatedAt, new Date().valueOf())}
									</Typography>
								</Box>
								{cmntData.hideComment === true
									? <Typography variant='caption' sx={{ color: 'gray', fontStyle: 'italic' }}>
										{language.commentHidden}
									</Typography> : <><Typography variant='caption' flexWrap='nowrap' component={'div'} p={1}>

										{isGif(cmntData?.comment)
											? (
												<img
													src={cmntData?.comment}
													alt='GIF'
													style={{ maxWidth: 'var(--percent100)', height: 'auto' }}
												/>
											)
											: (
												<>

													<Typography variant='body2' component='span' sx={{ wordBreak: 'break-all' }}>
														{displayedComment}
													</Typography>
													{shouldShowMore && (
														<Typography
															variant='caption'
															component='span'
															onClick={() => setShowMore((prev) => !prev)}
															pl='var(--pixel4)'
															color='var(--primaryColor)'
															sx={{ cursor: 'pointer' }}
														>
															{showMore ? language.less : language.more}
														</Typography>
													)}
												</>
											)}
									</Typography><Grid container direction='row' spacing={1}>
										<Grid item onClick={() => handleUpdateCmnt('updateLike', cmntData)}
											sx={{
												cursor        : 'pointer',
												display       : 'flex',
												alignItems    : 'center',
												color         : '#536471',
												'&:hover svg' : {
													backgroundColor : 'transparent',

													color     : '#23A4C4', // Hover color
													transform : 'scale(1.2)' // Hover scale
												}
											}}
										>
											{cmntData?.selfLike ? <HiThumbUp fontSize='var(--pixel18)' color='var(--primaryColor)' /> : <GoThumbsup fontSize='var(--pixel18)' />}
										</Grid>
										<Grid item sx={{ display: 'flex', alignItems: 'center' }} onClick={() => setLikePop(true)}>
											<Typography variant='caption' color='#536471' lineHeight={1.2}>
												<span className='pointer'>
													{Formatter((from === 'events' ? cmntData?.likeCount : cmntData?.likesCount) || 0)}
												</span> &nbsp;
												{(from === 'events' ? cmntData?.likeCount : cmntData?.likesCount) > 1 ? `${language?.likes}` : `${language?.like}`}

											</Typography>
										</Grid>
										<Grid item sx={{ display: 'flex', alignItems: 'center' }}>
											<Typography
												variant='caption'
												color='#536471'
												onClick={() => setAction({ reply: cmntData })}
												sx={{
													cursor      : 'pointer',
													position    : 'relative',
													paddingLeft : 'var(--pixel8)',
													'&::before' : {
														content         : '""',
														position        : 'absolute',
														left            : 0,
														top             : '2px',
														height          : '78%',
														width           : '1px',
														backgroundColor : 'rgba(83, 100, 113, 0.5)'
													}
												}}
											>
												{language?.reply}
											</Typography>
										</Grid>
									</Grid></>}
							</Box>
						</Grid>
						{(checkFromEventsOrFeed || canHide) && (
							<Grid item display='flex' justifyContent='flex-end'>
								<MdOutlineMoreHoriz fontSize='var(--pixel24)' color='#536471' onClick={handleClick} style={{ cursor: 'pointer' }}/>
							</Grid>
						)}
					</Grid>
				</Grid>
				{(cmntData?.repliesCount !== 0 && !openMoreReplies) && cmntData?.hideComment !== true &&
				<fieldset className='pointer' style={{ border: 'none' }}>
					<button tabIndex={0} onKeyUp={(e) => { e.key === 'Enter' && openReplies(); }} className='lightTxt headingSM pointer pdngHSM'
						onClick={openReplies}
					>{language?.view} {cmntData?.repliesCount} {language?.moreReplies}</button>
				</fieldset>}
				{/* Comments Replies... */}
				{(openMoreReplies &&
				cmntData.hideComment !== true) &&
				<CommentReply
					cmntData={cmntData}
					openReplies={openReplies}
					from={from}
					selEvent={selEvent}
					commntsData={commntsData}
					setCommntsData={setCommntsData}
				/>
				}
			</Box>

			{actionKeys[0] === 'delete' &&
			<NewDialogPopup
				open={Boolean(actionKeys[0] === 'delete')}
				closeCallBack={deleteComment}
				handleConfirm={() => setAction({})}
				type={language.no}
				id={undefined}
				label={language.deleteCommentWarning}
				from='feedCreate'
				formatType={language.yes}
			/>
			}

			{likePop &&
			<AvatarListPopup
				attendees={likePop}
				title={language.likes}
				handleAttendeesClose={() => setLikePop(false)}
				requestType='comment'
				requestId={cmntData?._id}
			/>
			}
			{anchorEl && ((!isGif(cmntData?.comment) && checkFromEventsOrFeed) || checkFromEventsOrFeed || canHide) ? (
				<Menu
					id='basic-menu'
					anchorEl={anchorEl}
					open={openMenu}
					onClose={() => setAnchorEl(null)}
					sx={{ marginLeft: '-6px' }}
					anchorOrigin={{
						vertical   : 'bottom',
						horizontal : 'left'
					}}
					transformOrigin={{
						vertical   : 'top',
						horizontal : 'left'
					}}
				>
					{!isGif(cmntData?.comment) && checkFromEventsOrFeed &&
					<MenuItem onClick={() => { setAction({ edit: cmntData }); setAnchorEl(null); handleUpdate(cmntData?.comment); }}>
						{language?.edit}</MenuItem>}
					{checkFromEventsOrFeed
						? <MenuItem onClick={() => { setAction({ delete: cmntData }); setAnchorEl(null); }}>
							{language?.delete}</MenuItem>
						: <MenuItem onClick={() => { handleUpdateCmnt('updateHide', cmntData); setAnchorEl(null); }}>
							{cmntData?.hideComment === true ? 'Unhide' : language?.hide}
						</MenuItem>

					}

				</Menu>) : null}
		</>
	);
};

export default IndividualCmnt;